import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
    sharedGridContainer: {
      paddingLeft: 8,
      paddingRight: 8
    },
    sharedGridContainerInner: {
      [theme.breakpoints.up("lg")]: {
        width: 1280
      }
    }
  });

class GridContainer extends Component {   
  render() {
    const { classes } = this.props
    return (
      <Grid className={classes.sharedGridContainer} container spacing={0} justify="center">
          <Grid className={classes.sharedGridContainerInner} container spacing={8}>
              { this.props.children }
          </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(GridContainer)


// WEBPACK FOOTER //
// ./src/components/shared/GridContainer.js